<template>
    <v-flex class="about-me" v-if="isAboutMeVisible || isCurrentUser">
        <v-flex tag="h2">{{memberProfileConstants.ABOUT_ME}}
            <i v-if="isCurrentUser"
                class="fas fa-pencil-alt ml-2"
                data-qe-id="member-profile_about-me_icon"
                @click="openAboutMeDialog()"></i>
        </v-flex>
        <v-flex v-if="!isAboutMeVisible && isCurrentUser">{{memberProfileConstants.DEFAULT_EDIT_TEXT.ABOUT_ME}}</v-flex>
        <v-flex :v-if="isBiographyVisible()" data-qe-id="biography_edit">
            <p class="about-me__biography">{{biographyInformation}}</p>
        </v-flex>
        <v-flex tag="span" v-if="!isBiographyVisible()" data-qe-id="biography_edit_dialog">
            <p>{{memberProfileConstants.DEFAULT_EDIT_TEXT.MY_BIOGRAPHY}}</p>
        </v-flex>
        <v-flex v-if="isFamilyDetailsVisible && !formerMemberNotGrandFather">
            <v-flex tag="h5" mb-1>{{memberProfileConstants.MY_FAMILY}}</v-flex>
            <v-flex class="status" v-if="familyDetails.Member[0].relationshipStatus">{{memberProfileConstants.RELATIONSHIP_STATUS}}: <v-flex tag="strong">{{familyDetails.Member[0].relationshipStatus}}</v-flex></v-flex>
            <v-flex class="my-family">
                <v-layout row wrap>
                    <v-flex>
                        <v-flex v-if="!isFamilyMembersAvailable && isCurrentUser" data-qe-id="biography_edit_default" tag="p">{{memberProfileConstants.DEFAULT_EDIT_TEXT.MY_FAMILY}}
                        </v-flex>
                        <status-overlay :action="loadFamilyDetailsAction" content-height="240px">
                        </status-overlay>
                    </v-flex>
                    <v-flex xs12 sm6 v-for="(row, idx1) in familyMatrix" :key="idx1">
                        <v-flex class="my-family__row" v-for="(col, idx2) in row" :key="idx2">
                            <figure>
                                <img :class="!isYPOMember(familyMatrix[idx1][idx2].category, familyMatrix[idx1][idx2].familyInfo.recordTypeName) ? 'my-family__classIsYPOMember' : 'my-family__imgIsYPOMember'"
                                    :src="familyMatrix[idx1][idx2].familyInfo.profileImageUrl"
                                    @click="openMemberProfile(familyMatrix[idx1][idx2])"
                                    :data-qe-id="`member_family-image-${idx1}`"
                                    :onerror="getDefaultImage(familyMatrix[idx1][idx2].familyInfo.fallbackProfileImageUrl)" />
                            </figure>
                            <v-flex tag="strong">
                                <a :class="!isYPOMember(familyMatrix[idx1][idx2].category, familyMatrix[idx1][idx2].familyInfo.recordTypeName) ? 'my-family__classIsYPOMember' : ''"
                                    :data-qe-id="`member_family-${idx1}`"
                                    @click="openMemberProfile(familyMatrix[idx1][idx2])">
                                    {{familyMatrix[idx1][idx2] ? getName(familyMatrix[idx1][idx2].familyInfo) : null}}
                                </a>
                            </v-flex>
                            <v-flex tag="small">{{getGender(familyMatrix[idx1][idx2])}}</v-flex>
                            <router-link v-if="familyMatrix[idx1][idx2].category=== memberProfileConstants.SPOUSE"
                                        :data-qe-id="`member_family-${idx1}_chapter`"
                                        :to="{path : `/chapter/${familyMatrix[idx1][idx2].familyInfo.primaryChapterId}`, query: { name: familyMatrix[idx1][idx2].familyInfo.primaryChapter }}"
                                        class="my-family__removeUnderLine">
                                {{familyMatrix[idx1][idx2].familyInfo.primaryChapter}}
                            </router-link>
                        </v-flex>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-flex>
        <v-flex tag="h5" v-if="familyInterests.Personal_Family || isCurrentUser">{{memberProfileConstants.MY_PERSONAL_FAMILY_INTERESTS}}</v-flex>
        <v-flex v-if="!familyInterests.Personal_Family && isCurrentUser"> {{memberProfileConstants.DEFAULT_EDIT_TEXT.MY_PERSONAL_FAMILY_INTERESTS}} </v-flex>
        <v-flex v-for="interestKey in Object.keys(interests).sort()" :key="interestKey" class="about-me__row">
            <v-flex tag="strong">{{interestKey}}</v-flex>
            <v-layout row wrap>
                <v-flex xs6 v-for="(row, idx1) in familyInterestMatrix = getInterests(interests[interestKey],memberProfileConstants.FAMILY_COLUMN_LIMIT)" :key="idx1">
                    <v-flex tag="span" v-for="(col, idx2) in row" :key="idx2">{{familyInterestMatrix[idx1][idx2].subCategoryName}}</v-flex>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-dialog scrollable v-model="isAboutMeDialog" content-class="medium">
            <v-card @click="hideRelationStatusDropDown" class="myprofile-popup" data-qe-id="member-profile_hide-relationship-dropdown">
                <v-card-title primary-title>
                    {{memberProfileConstants.ABOUT_ME_SECTION.EDIT_ABOUT_ME}}
                    <i class="fas fa-times" @click="isAboutMeDialog = false , showStatusDropdown=false"  data-qe-id="close_biography-popup"></i>
                </v-card-title>
                <v-card-text class="inner-scrollbar" v-if="isAboutMeDialog">
                    <v-flex class="details-view">
                        <v-flex tag="h6">{{memberProfileConstants.ABOUT_ME_SECTION.MY_BIOGRAPHY}}
                            <i  @click="openBiographyEdit()"
                                data-qe-id="member-profile_biography"
                                class="fas fa-pencil-alt"></i>
                        </v-flex>
                        <v-flex :v-if="isBiographyVisible()">
                            <p class="about-me__biography">{{biographyInformation}}</p>
                        </v-flex>
                        <v-flex tag="span" v-if="!isBiographyVisible()">
                            <p>{{memberProfileConstants.DEFAULT_EDIT_TEXT.MY_BIOGRAPHY}}</p>
                        </v-flex>
                    </v-flex>
                    <v-flex class="details-view">
                        <v-flex tag="h6">{{memberProfileConstants.MY_FAMILY}}
                            <span class="add-edit-btn"
                                v-if="isFamilyEdit || isGrandFather"
                                data-qe-id="member-profile_my-family"
                                @click="openFamilyMember()">
                                <i class="fas fa-pencil-alt"></i>
                                <i class="fas fa-plus-circle"></i>
                            </span>
                        </v-flex>
                        <v-flex class="about-me my-family">
                            <v-flex row wrap v-if="familyDetails.Member" class="my-family__status">
                                <span>{{memberProfileConstants.RELATIONSHIP_STATUS}}:</span>
                                <span v-if="!showStatusDropdown"><strong>{{familyDetails.Member[0].relationshipStatus}}</strong>
                                        <i class="fas fa-pencil-alt"
                                            id="editShowOrHideRelationshipDropDown"
                                            data-qe-id="member-profile_family-1_status"
                                            @click="showStatusDropdown=true"></i>
                                </span>
                                <span v-if="showStatusDropdown">
                                    <v-autocomplete
                                        attach
                                        id="ddlShowOrHideRelationshipDropDown"
                                        color="ypo_blue"
                                        data-qe-id="statusDropdown"
                                        @input="saveRelationshipStatusDetails()"
                                        :items="relationshipStatusTypes"
                                        item-text="relationshipStatus1"
                                        v-model="familyDetails.Member[0].relationshipStatus">
                                    </v-autocomplete>
                                </span>
                            </v-flex>
                            <v-layout row wrap>
                                <v-flex v-if="!isFamilyMembersAvailable" tag="p">{{memberProfileConstants.DEFAULT_EDIT_TEXT.MY_FAMILY}}
                                </v-flex>
                                <v-flex xs12 sm6 v-for="(row, idx1) in familyMatrix" :key="idx1">
                                    <v-flex class="about-me my-family__row" v-for="(col, idx2) in row" :key="idx2">
                                        <figure>
                                            <img :class="!isYPOMember(familyMatrix[idx1][idx2].category, familyMatrix[idx1][idx2].familyInfo.recordTypeName) ? 'my-family__classIsYPOMember' : 'my-family__imgIsYPOMember'"
                                                :src="familyMatrix[idx1][idx2].familyInfo.profileImageUrl"
                                                @click="openMemberProfile(familyMatrix[idx1][idx2])"
                                                :data-qe-id="`member-profile_edit-family-image_${idx1}`"
                                                :onerror="getDefaultImage(familyMatrix[idx1][idx2].familyInfo.fallbackProfileImageUrl)" />
                                        </figure>
                                            <v-flex tag="strong" ml-0>
                                                <a :class="!isYPOMember(familyMatrix[idx1][idx2].category, familyMatrix[idx1][idx2].familyInfo.recordTypeName) ? 'my-family__classIsYPOMember' : ''"
                                                    :data-qe-id="`member-profile_edit-family_${idx1}`"
                                                    @click="openMemberProfile(familyMatrix[idx1][idx2])">
                                                    {{familyMatrix[idx1][idx2] ? getName(familyMatrix[idx1][idx2].familyInfo) : null}}
                                                </a>
                                                <i class="fas fa-pencil-alt"
                                                    @click="editFamilyMember(familyMatrix[idx1][idx2])"
                                                    :data-qe-id="`member-profile_edit-family-edit_${idx1}_link`"
                                                    v-if="familyMatrix[idx1][idx2].familyInfo.isEditable">
                                                </i>
                                            </v-flex>
                                            <v-flex tag="small" ml-0>{{getGender(familyMatrix[idx1][idx2])}}</v-flex>
                                            <router-link v-if="familyMatrix[idx1][idx2].category=== memberProfileConstants.SPOUSE"
                                                        :data-qe-id="`member-profile_edit-family_${idx1}-chapter`"
                                                        :to="{path : `/chapter/${familyMatrix[idx1][idx2].familyInfo.primaryChapterId}`, query: { name: familyMatrix[idx1][idx2].familyInfo.primaryChapter }}"
                                                        class="my-family__removeUnderLine">{{familyMatrix[idx1][idx2].familyInfo.primaryChapter}}
                                            </router-link>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-flex>
                    <v-flex class="details-view">
                        <v-flex tag="h6">{{memberProfileConstants.MY_PERSONAL_FAMILY_INTERESTS}}
                            <i class="fas fa-pencil-alt"
                                data-qe-id="member-profile_open-personal-interest_link"
                                @click="openPersonalInterestDialog()">
                            </i>
                        </v-flex>
                        <v-flex v-if="!familyInterests.Personal_Family"> {{memberProfileConstants.DEFAULT_EDIT_TEXT.MY_PERSONAL_FAMILY_INTERESTS}} </v-flex>
                        <v-flex tag="h5" v-if="familyInterests.Personal_Family"></v-flex>
                        <v-flex v-for="interestKey in Object.keys(interests).sort()" :key="interestKey" class="about-me__row">
                            <v-flex tag="strong">{{interestKey}}</v-flex>
                            <v-layout row wrap>
                                <v-flex xs12 sm4 v-for="(row, idx1) in familyInterestMatrix = getInterests(interests[interestKey],memberProfileConstants.MY_FAMILY_COLUMN_LIMIT)" :key="idx1">
                                    <v-flex tag="span" v-for="(col, idx2) in row" :key="idx2">{{familyInterestMatrix[idx1][idx2].subCategoryName}}</v-flex>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-flex text-xs-right pa-3>
                    <v-btn flat class="primary_btn" @click="isAboutMeDialog = false , showStatusDropdown=false "
                        data-qe-id="close_dialog_btn">
                        {{appCommonConstants.CLOSE}}
                    </v-btn>
                </v-flex>
            </v-card>
        </v-dialog>
        <v-dialog scrollable v-model="isMyFamilyDialog" persistent content-class="medium">
            <FamilyMember
                v-if="isMyFamilyDialog"
                :memberType="memberType"
                :AllFamilyDetails="AllFamilyDetails"
                :familyDetail="familyDetail"
                :familyDetails="familyDetails"
                @click="handleDialog"
                :isFamilyEditDialog="isFamilyEditDialog"
                :isSave="isSave"
                :hasSpouse="hasSpouse"
                :isMemberSpouse ="isMemberSpouse"
                :memberId="memberId" />
        </v-dialog>
        <v-dialog scrollable v-model="isMyFamilyInterestDialog" v-if="isMyFamilyInterestDialog" content-class="medium">
            <v-card class="myprofile-popup">
                <v-card-title primary-title>
                    {{memberProfileConstants.ABOUT_ME_SECTION.EDIT_MY_FAMILY_INTEREST}}
                    <i class="fas fa-times"
                        data-qe-id="close_dialog_btn"
                        @click="closePersonalInterestDialog()"></i>
                </v-card-title>
                <v-card-text :class="firstTimecollapse ? 'inner-scrollbar-family-interest': 'inner-scrollbar'">
                    <v-form>
                        <v-flex tag="p">
                            {{memberProfileConstants.ABOUT_ME_SECTION.EDIT_MY_FAMILY_INTEREST_TEXT}}
                        </v-flex>
                        <v-layout row wrap>
                            <v-flex xs12 sm8>
                                <v-flex class="form-control">
                                    <span class="select-label">{{memberProfileConstants.ABOUT_ME_SECTION.EDIT_MY_FAMILY_INTEREST_TEXT1}} </span>
                                        <v-expansion-panel class="custom-expansion-panel"  v-model="personalInterestPanel" >
                                            <v-expansion-panel-content>
                                            <div slot="header" class="header_title">
                                                {{ defaultSelected || memberProfileConstants.SELECT_INTEREST }}
                                            </div>
                                            <div v-for="interest in Object.keys(personalInterests).sort()" :key="interest" @click="handleStuff(interest)">
                                                <span class="expansion-panel-content">{{ interest }}</span>
                                            </div>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    <span class="select-label">{{memberProfileConstants.ABOUT_ME_SECTION.EDIT_MY_FAMILY_INTEREST_TEXT2}} </span>
                                </v-flex>
                            </v-flex>
                            <v-flex v-if="personalInterestPanel" class="form-control familyInterests mt-3">
                                <v-layout row wrap>
                                    <v-flex xs12 sm4 v-for="(row, idx1) in  abc = getInterests(subCategory, 3)" :key="idx1">
                                        <span class="familyInterests__list" v-for="(col, idx2) in row" :key="idx2">
                                        <v-checkbox
                                            color="ypo_blue"
                                            :label="abc[idx1][idx2].subCategoryName"
                                            v-model="abc[idx1][idx2].interest"
                                            :id="`subcategory_checkbox${idx1}`"
                                            v-on:change="chooseInterest(abc[idx1][idx2])">
                                        </v-checkbox>
                                    </span>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>
                <status-bar :action="saveInterestsAction"></status-bar>
                <v-card-actions>
                    <v-flex text-xs-right pa-3>
                        <v-flex>
                            <v-btn class="primary_btn transparent" data-qe-id="editmypersonalfamilyinterest_cancelBtn" @click="closePersonalInterestDialog()">
                                {{appCommonConstants.CANCEL}}
                            </v-btn>
                            <v-btn
                                class="primary_btn"
                                :disabled="isDisabled"
                                data-qe-id="editmypersonalfamilyinterest_saveBtn"
                                @click="savePersonalInterests()">
                                {{appCommonConstants.DONE}}
                            </v-btn>
                        </v-flex>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="spouseAlertDialog"
            lazy
            absolute
            content-class="post-actions">
            <v-card>
                <v-flex tag="h6">{{memberProfileConstants.SPOUSE_ALERT_TITLE}}
                    <v-btn icon @click="spouseAlertDialog=false;isMyFamilyDialog = true;" data-qe-id="cancel_dialog_btn">
                        <v-icon size="20">close</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex tag="p">
                    {{memberProfileConstants.SPOUSE_ALERT_TEXT}}
                </v-flex>
                <v-flex text-xs-right>
                    <v-btn dark @click="spouseAlertDialog=false;isMyFamilyDialog = true;" class="primary_btn" data-qe-id="close_dialog_btn">
                        {{appCommonConstants.CLOSE}}
                    </v-btn>
                </v-flex>
            </v-card>
        </v-dialog>
        <biography-edit-dialog v-model="isBiographyDialogEdit" v-if="isBiographyDialogEdit" :memberId="memberId" :myBiographyData="myBiographyData"></biography-edit-dialog>
    </v-flex>
</template>

<script>
    import { memberProfileConstants, displayAge } from "./memberProfile.constants.js";
    import { mapState, mapActions, mapGetters } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { appCommonConstants } from "../appCommon.constants.js";
    import BiographyEditDialog from "./EditDialogues/BiographyEditDialog";
    import FamilyMember from "./EditDialogues/FamilyMember.vue";
    import Vue from 'vue';
    import StatusBar from "../StatusBar/StatusBar";
    import { eventBus } from '../../main';
    import StatusOverlay from '../StatusOverlay/StatusOverlay';
    import { uuid } from 'vue-uuid';
    import { gaDataLayerEvent } from "@/plugins/analytics";
    import { gtmEventName } from "@/plugins/gtmAnalytics";

    export default {
        name: "AboutMe",
        data: () => ({
            memberProfileConstants,
            appCommonConstants,
            interests: [],
            spouse: [],
            familyMatrix: [],
            familyMemberData: [],
            isAboutMeDialog: false,
            isMyFamilyInterestDialog: false,
            spouseAlertDialog: false,
            subCategory: [],
            isBiographyDialogEdit: false,
            showStatusDropdown: false,
            colLimit: 0,
            isMyFamilyDialog: false,
            memberType: '',
            AllFamilyDetails: [],
            isFamilyEditDialog: false,
            gender: '',
            personalInterests: [],
            isDisabled: true,
            defaultSelected: '',
            changedCatgories: [],
            isSave: false,
            hasSpouse: false,
            isMemberSpouse: false,
            myBiographyData: "",
            isFamilyEditable: false,
            personalInterestPanel: false,
            firstTimecollapse: false,
            familyDetail: {
                id: null,
                name: null,
                firstName: null,
                dateOfBirth: null,
                primaryChapter: null,
                primaryChapterId: null,
                lastName: null,
                webLoginIdhistorical: null,
                email: null,
                username: null,
                percentageProfileComplete: null,
                middleName: null,
                preferredName: null,
                biography: null,
                type: null,
                gender: null,
                relationshipStatus: null,
                birthdate: null,
                phone: null,
                salesforceAccessfromExchange: false,
                cventAccessfromExchange: false,
                suffix: null,
                displayName: null,
                portalUserName: null,
                profileImageUrl: null,
                memberType: null,
                salutation: null,
                isEdit: false,
                isDelete: true,
                isAdd: false,
                isSuccess: false,
                isEditDialog: false,
                isSpouseSelected: false,
                recordTypeName: null,
                portalAccessLevel: null,
                hasYpoExchangeAccess: true,
                datePickerMenu: false,
                isValid: false,
            },
        }),
        components: {
            BiographyEditDialog,
            StatusBar,
            FamilyMember,
            StatusOverlay,
        },
        props: {
            memberId: {
                type: String,
                required: true,
            },
            isFormerMember: {
                type: Boolean,
                required: false,
            },
        },
        created() {
          if (this.memberId) {
            this.getBiography(this.memberId);
            if (!this.$store.getters[`memberProfile/${storeGetters.isFamilyInterestsLoading}`]) {
              this.getFamilyInterests(this.memberId);
            }
            this.getFamilyDetails(this.memberId);
          }
            eventBus.$on('isBiographyDialogEdit', ((value) => {
                this.isBiographyDialogEdit = value;
            }));
        },
        methods: {
            ...mapActions({
                getBiography: `memberProfile/${storeAction.getBiography}`,
                getFamilyDetails: `memberProfile/${storeAction.getFamilyDetails}`,
                getFamilyInterests: `memberProfile/${storeAction.getFamilyInterests}`,
                saveRelationshipStatus: `memberProfile/${storeAction.saveRelationshipStatus}`,
                savePersonInterests: `memberProfile/${storeAction.savePersonInterests}`,
            }),
            getName(familyInfo) {
                if (familyInfo) {
                    return `${familyInfo.firstName} ${familyInfo.lastName}`;
                }
            },
            handleStuff(option) {
                this.firstTimecollapse = true;
                this.getSubCategory(option);
                this.defaultSelected = option;
                this.personalInterestPanel = true;
            },
            getGender(familyData) {
                if (familyData.category !== this.memberProfileConstants.SPOUSE) {
                    let ageStatement = '';
                    if (familyData.familyInfo.birthdate) {
                        ageStatement = displayAge(familyData.familyInfo.birthdate); 
                    }
                    const peerType = (familyData.familyInfo.gender === this.memberProfileConstants.MALE) ? 
                                    this.memberProfileConstants.SON : 
                                    (familyData.familyInfo.gender === this.memberProfileConstants.FEMALE ? 
                                        this.memberProfileConstants.DAUGHTER : 
                                        '');
                    if (ageStatement) {
                        return peerType ? `${peerType}, ${ageStatement}` : ageStatement;
                    }
                    return peerType || '';
                }
                return familyData.category;
            },
            isBiographyVisible() {
                return this.biographyInformation.trim();
            },
            isYPOMember(isSpousePartner, isYpoMember) {               
                return (isSpousePartner === this.memberProfileConstants.SPOUSE) || isYpoMember === this.memberProfileConstants.MEMBER;
            },
            getInterests(interests, colLimit) {
                let interestMatrix = [];
                interestMatrix = new Array(colLimit);
                for (let i = 0; i < interestMatrix.length; i += 1) {
                    interestMatrix[i] = [];
                }
                const rowLimit = (interests.length % colLimit) === 0 ? Math.floor(interests.length / colLimit) : Math.floor(interests.length / colLimit) + 1;
                interests.forEach((ci, i) => {
                    const colNum = Math.floor(i / rowLimit);
                    const rowNum = i % rowLimit;
                    interestMatrix[colNum][rowNum] = ci;
                });
                return interestMatrix;
            },
            openMemberProfile(data) {
                if (data.category === this.memberProfileConstants.SPOUSE || data.familyInfo.recordTypeName === this.memberProfileConstants.MEMBER) {
                    this.$router.push({
                        path: '/memberProfile',
                        query: { memberId: data.familyInfo.id, name: `${this.familyDetails.Member[0].name}` },
                    });
                }
            },
            openPersonalInterestDialog() {
                this.isMyFamilyInterestDialog = true;
            },
            closePersonalInterestDialog() {
                this.defaultSelected = '';
                this.subCategory = [];
                this.changedCatgories = [];
                this.isMyFamilyInterestDialog = false;
                this.isDisabled = true;
                this.firstTimecollapse = false;
            },
            getSubCategory(value) {
                this.subCategory = this.personalInterests[value];
            },
            chooseInterest(interest) {
                this.isDisabled = false;
                const index = this.changedCatgories.indexOf(interest.categoryName);
                if (index === -1) {
                    this.changedCatgories.push(interest.categoryName);
                }
            },
            saveRelationshipStatusDetails() {
                const parms = {
                    personId: this.memberId,
                    relationshipStatus: this.familyDetails.Member[0].relationshipStatus,
                };
                this.showStatusDropdown = false;
                if (this.familyDetails.Member[0].relationshipStatus !== "") {
                    this.saveRelationshipStatus(parms);
                    gaDataLayerEvent(gtmEventName.C_Profile_Edit, `Relationship - ${this.memberId}${this.isRedirectFromConnectPlus ? ' | Connect+ Redirect' : ''}`);
                }
            },
            openFamilyMember() {
                this.isFamilyEditDialog = false;
                this.isMyFamilyDialog = true;
                this.isSave = false;
                this.AllFamilyDetails = [];
                this.familyDetail.id = uuid.v1();
                this.AllFamilyDetails.push(Vue.util.extend({}, this.familyDetail));
            },
            editFamilyMember(familyMemberDetails) {
                this.familyMemberData = familyMemberDetails.familyInfo;
                if (familyMemberDetails.category !== this.memberProfileConstants.SPOUSE) {
                    if (familyMemberDetails.familyInfo.gender === this.memberProfileConstants.MALE) {
                        this.memberType = this.memberProfileConstants.SON;
                        this.gender = familyMemberDetails.familyInfo.gender;
                    } else {
                        this.memberType = this.memberProfileConstants.DAUGHTER;
                        this.gender = familyMemberDetails.familyInfo.gender;
                    }
                } else {
                    this.memberType = this.memberProfileConstants.SPOUSE;
                    this.familyMemberData.isSpouseSelected = true;
                    this.familyMemberData.hasYpoExchangeAccess = this.familyMemberData.portalAccessLevel !== null;
                }
                this.spouseFamilyMember(this.familyMemberData, this.memberType, this.gender);
            },
            spouseFamilyMember(familyInfo, type) {
                this.AllFamilyDetails = [{
                    id: familyInfo.id,
                    name: familyInfo.name,
                    firstName: familyInfo.firstName,
                    dateOfBirth: familyInfo.dateOfBirth,
                    primaryChapter: familyInfo.primaryChapter,
                    primaryChapterId: familyInfo.primaryChapterId,
                    lastName: familyInfo.lastName,
                    webLoginIdhistorical: familyInfo.webLoginIdhistorical,
                    email: familyInfo.email,
                    username: familyInfo.username,
                    percentageProfileComplete: familyInfo.percentageProfileComplete,
                    middleName: familyInfo.middleName,
                    preferredName: familyInfo.preferredName,
                    biography: familyInfo.biography,
                    type: familyInfo.type,
                    gender: this.gender,
                    relationshipStatus: familyInfo.relationshipStatus,
                    phone: familyInfo.phone,
                    salesforceAccessfromExchange: familyInfo.salesforceAccessfromExchange,
                    cventAccessfromExchange: familyInfo.cventAccessfromExchange,
                    suffix: familyInfo.suffix,
                    displayName: familyInfo.displayName,
                    portalUserName: familyInfo.portalUserName,
                    profileImageUrl: familyInfo.profileImageUrl,
                    memberType: type,
                    confirmEmailAddress: familyInfo.email,
                    salutation: familyInfo.salutation,
                    isEditDialog: true,
                    birthdate: this.getBirthDate(familyInfo.birthdate),
                    isSpouseSelected: familyInfo.isSpouseSelected,
                    recordTypeName: familyInfo.recordTypeName,
                    portalAccessLevel: familyInfo.portalAccessLevel,
                    hasYpoExchangeAccess: !!familyInfo.portalAccessLevel,
                    uniqueEmail: false,
                }];
                if (familyInfo.recordTypeName !== this.memberProfileConstants.MEMBER && familyInfo.isSpouseSelected) {
                    this.spouseAlertDialog = true;
                    this.isFamilyEditDialog = true;
                    this.isSave = true;
                } else {
                    this.isMyFamilyDialog = true;
                    this.isFamilyEditDialog = true;
                    this.isSave = true;
                }
            },
            hideRelationStatusDropDown(event) {
                if ((event.target.id === '' && event.target.innerText === 'arrow_drop_down') || event.target.className === 'v-select__selections' || event.target.className === 'v-icon material-icons theme--light' || event.target.className === 'v-select__selection v-select__selection--comma') {
                    this.showStatusDropdown = true;
                } else if (event.target.id === '') {
                    this.showStatusDropdown = false;
                }
            },
            handleDialog(variable) {
                this.isMyFamilyDialog = variable;
            },
            openBiographyEdit() {
                this.isBiographyDialogEdit = true;
                this.myBiographyData = this.biographyInformation.trim();
            },
            closeBiographyEdit() {
                this.isBiographyDialogEdit = false;
                this.myBiographyData = "";
            },
            getInterestsTypes(val) {
                const arrFamilyInterests = [];
                Object.keys(val).forEach((key) => {
                    arrFamilyInterests[key] = [];
                    val[key].forEach((x) => {
                        if (this.interests[key]) {
                            const categoryExists = this.interests[key].some((el) => {
                                if (el.subCategoryName === x.subCategory) {
                                    return arrFamilyInterests[key].push({
                                        id: x.id,
                                        categoryName: key,
                                        subCategoryName: el.subCategoryName,
                                        interest: true,
                                    });
                                }
                                return false;
                            });
                            if (!categoryExists) {
                                arrFamilyInterests[key].push({
                                    id: x.id,
                                    categoryName: key,
                                    subCategoryName: x.subCategory,
                                    interest: false,
                                });
                            }
                        } else {
                            arrFamilyInterests[key].push({
                                id: x.id,
                                categoryName: key,
                                subCategoryName: x.subCategory,
                                interest: false,
                            });
                        }
                    });
                });
                return arrFamilyInterests;
            },
            savePersonalInterests() {
                const saveInterest = [];
                this.changedCatgories.forEach((key) => {
                    if (!this.personalInterests[key] || this.personalInterests[key].length === 0) {
                        return false;
                    }
                    this.personalInterests[key].forEach((x) => {
                        if (this.familyInterests.Personal_Family) {
                            if (x.interest === true) {
                                const index = this.familyInterests.Personal_Family.findIndex(y => y.subCategoryName === x.subCategoryName && y.categoryName === key && y.typePersonSkill === this.memberProfileConstants.ABOUT_ME_SECTION.INTEREST);
                                if (index === -1) {
                                    return saveInterest.push({
                                        id: uuid.v1(),
                                        skillId: x.id,
                                        categoryName: key,
                                        subCategoryName: x.subCategoryName,
                                        themeName: this.memberProfileConstants.BUSINESS,
                                        typePersonSkill: this.memberProfileConstants.ABOUT_ME_SECTION.INTEREST,
                                        isActivePersonSkill: x.interest,
                                        personId: this.memberId,
                                    });
                                }
                            } else {
                                this.familyInterests.Personal_Family.some((el) => {
                                    if (el.categoryName === key && el.subCategoryName === x.subCategoryName) {
                                        if (el.typePersonSkill === this.memberProfileConstants.ABOUT_ME_SECTION.INTEREST && x.interest === false) {
                                            saveInterest.push({
                                                id: el.id,
                                                skillId: el.skillId,
                                                categoryName: el.categoryName,
                                                subCategoryName: el.subCategoryName,
                                                themeName: this.memberProfileConstants.ABOUT_ME_SECTION.PERSONAL_FAMILY,
                                                typePersonSkill: this.memberProfileConstants.ABOUT_ME_SECTION.INTEREST,
                                                isActivePersonSkill: x.interest,
                                                personId: this.memberId,
                                            });
                                        }
                                    }
                                    return false;
                                });
                            }
                        } else if (!this.familyInterests.PERSONAL_FAMILY && x.interest === true) {
                            saveInterest.push({
                                id: uuid.v1(),
                                skillId: x.id,
                                categoryName: x.categoryName,
                                subCategoryName: x.subCategoryName,
                                themeName: this.memberProfileConstants.ABOUT_ME_SECTION.PERSONAL_FAMILY,
                                typePersonSkill: this.memberProfileConstants.ABOUT_ME_SECTION.INTEREST,
                                isActivePersonSkill: x.interest,
                                personId: this.memberId,
                            });
                        }
                    });
                });
                const postBody = { "Personal_Family": saveInterest };
                this.savePersonInterests(postBody)
                    .then(() => {
                        this.isDisabled = true;
                        this.isMyFamilyInterestDialog = false;
                        this.defaultSelected = '';
                        this.subCategory = [];
                        this.changedCatgories = [];
                        this.firstTimecollapse = false;
                        gaDataLayerEvent(gtmEventName.C_Profile_Edit, `Interests - ${this.memberId}${this.isRedirectFromConnectPlus ? ' | Connect+ Redirect' : ''}`);
                    })
                    .catch(() => {
                        this.isDisabled = true;
                    });
            },
            getBirthDate(data) {
                if (data) {
                    return data.split('T')[0];
                }
                return null;
            },
            getDefaultImage(url) {
                if (url) {
                    return `this.src="${url}";`;
                }
            },
            openAboutMeDialog() {
                this.isAboutMeDialog = true;
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                biographyInformation: `memberProfile/${storeGetters.biographyInformation}`,
                familyDetails: `memberProfile/${storeGetters.familyDetails}`,
                isAboutMeVisible: `memberProfile/${storeGetters.isAboutMeVisible}`,
                familyInterests: `memberProfile/${storeGetters.familyInterests}`,
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                familyInterestTypes: `memberProfile/${storeGetters.familyInterestTypes}`,
                relationshipStatusTypes: `memberProfile/${storeGetters.relationshipStatusTypes}`,
                chapterAdminEditable: `memberProfile/${storeGetters.chapterAdmin}`,
                userProfile: `memberProfile/${storeGetters.userProfile}`,
            }),
            isRedirectFromConnectPlus() {
              return this.$route && this.$route.query
                && this.$route.query.connectPlusRedirect && this.$route.query.connectPlusRedirect === 'true';
            },
            isCurrentUser() {
                return this.memberId === this.currentUserId || this.chapterAdminEditable;
            },
            isFamilyEdit() {
                return (this.memberId === this.currentUserId && this.isFamilyEditable) || this.chapterAdminEditable;
            },
            isFamilyMembersAvailable() {
                return (this.familyMatrix.length > 0) && (this.familyMatrix[0].length > 0 || this.familyMatrix[1].length > 0);
            },
            saveInterestsAction() {
                return this.actions[storeAction.savePersonInterests];
            },
            isFamilyDetailsVisible() {
                return this.familyDetails && (this.familyDetails.Member[0].relationshipStatus || this.isFamilyMembersAvailable);
            },
            loadFamilyDetailsAction() {
                return this.actions[storeAction.getFamilyDetails];
            },
            isGrandFather() {
                return this.userProfile.ypoMemberType === memberProfileConstants.GRAND_FATHER_MEMBER;
            },
            formerMemberNotGrandFather() {
                return this.isFormerMember && !this.isGrandFather;
            },
        },
        watch: {
            biographyInformation(val) {
                if (val) {
                    this.myBiographyData = val.trim();
                }
            },
            familyDetails(val) {
                this.familyMatrix = [];
                this.spouse = [];
                this.hasSpouse = false;
                if (val) {
                    const member = val.Member[0];
                    Object.keys(val).forEach((key) => {
                        if (key !== this.memberProfileConstants.MEMBER) {
                            Object.values(val[key]).forEach((familyInfo) => {
                                familyInfo.isEditable = true;
                                familyInfo.profileImageUrl = familyInfo.profilePictureuploaded ? familyInfo.profileImageUrl : familyInfo.fallbackProfileImageUrl;
                                if (key === this.memberProfileConstants.SPOUSE) {
                                    this.hasSpouse = true;
                                    if (member && member.recordTypeName === this.memberProfileConstants.SPOUSE) {
                                        familyInfo.isEditable = false;
                                    }
                                }
                                this.spouse.push({
                                    familyInfo,
                                    category: key === this.memberProfileConstants.CHILD ? this.memberProfileConstants.CHILD : key,
                                });
                            });
                        } else {
                            this.isMemberSpouse = Object.values(val[key]).some(x => x.recordTypeName === this.memberProfileConstants.SPOUSE);
                            this.isFamilyEditable = Object.values(val[key]).some(x => x.recordTypeName === this.memberProfileConstants.MEMBER || x.recordTypeName === this.memberProfileConstants.SPOUSE);
                        }
                    });
                }
                const colLimit = this.memberProfileConstants.FAMILY_COLUMN_LIMIT;
                this.familyMatrix = new Array(colLimit);
                for (let i = 0; i < this.familyMatrix.length; i += 1) {
                    this.familyMatrix[i] = [];
                }
                const rowLimit = (this.spouse.length % colLimit) === 0 ? Math.floor(this.spouse.length / colLimit) : Math.floor(this.spouse.length / colLimit) + 1;
                this.spouse.forEach((ci, i) => {
                    const colNum = Math.floor(i / rowLimit);
                    const rowNum = i % rowLimit;
                    this.familyMatrix[colNum][rowNum] = ci;
                });
            },
            familyInterests(val) {
                this.interests = [];
                if (val.Personal_Family) {
                    val.Personal_Family.forEach((x) => {
                        const list = this.interests[x.categoryName];
                        if (list) {
                            list.push(x);
                        } else {
                            if (x.isActivePersonSkill === false) {
                                return false;
                            }
                            this.interests[x.categoryName] = [x];
                        }
                    });
                    return this.interests;
                }
            },
            familyInterestTypes(val) {
                this.personalInterests = this.getInterestsTypes(val);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";
    @import '../../common/styles/_commonClasses.scss';

    .inner-scrollbar-family-interest {
    @extend %inner-scrollbar;

    height: 550px;
        @include breakpoint(xs) {
            height: 600px;
        }
    }
    .expansion-panel-content{
        display:block;
        padding: 6px;
        font-size: 15px;
        margin-left: 10px;
        cursor: pointer;
        color:black;
    }
    .header_title{
        margin-left: -22px;
    }
    .about-me {
        margin-top: 20px;
        padding: 0 20px 20px 20px;
        position: relative;

        &__biography {
            text-align: justify;
            word-wrap: break-word;
            white-space: pre-line;
        }

        &__row {
            margin-top: 20px;

            strong {
                display: block;
                margin-bottom: 5px;
            }

            span {
                display: block;
                margin-bottom: 3px;
            }
        }

        .my-family {
            &__removeUnderLine {
                text-decoration: none;
            }
            &__classIsYPOMember {
                max-width: 100%;
                cursor: auto;
                height: 100%;
                width: 100%;          
            }
            &__imgIsYPOMember {
                max-width: 100%;
                cursor: pointer;
                height: 100%;
                width: 100%;
            }
            &__row {
                position: relative;
                padding-left: 90px;
                min-height: 70px;
                margin-bottom: 30px;

                figure {
                    max-width: 65px;
                    border-radius: 50%;
                    position: absolute;
                    left: 0;
                    max-height: 65px;
                    overflow: hidden;
                }

                strong {
                    padding-top: 5px;
                    display: block;
                    word-break: break-all; 
                }

                small {
                    display: block;
                }
            }

            &__status {
                span {
                    display: inline-block;
                    margin-right: 10px;
                    color: $ypo-blue;

                    strong {
                        margin-left: 0px;
                        display: inherit;                        
                    }
                }
            }
        }

        .status {
            display: block;
            margin: 10px 0 15px 0;
            color: rgba($ypo-gray-text, 0.6);

            strong {
                font-weight: 500;
                color: $ypo-gray-text;
            }
        }

        h2 {
            color: $ypo_blue;
            font-family: "Raleway", sans-serif;
            font-size: 22px;
            font-weight: 500;
            margin-bottom: 20px;
            line-height: 26px;

            span {
                color: $ypo-cta;
                font-size: 14px;
                font-weight: bold;
                line-height: 19px;
                cursor: pointer;
            }
        }

        h5 {
            color: $ypo_blue;
            font-size: 16px;
            font-weight: bold;
            line-height: 26px;
        }

        @media (max-width: 1199px){
            padding: 0 0 20px 0;
        }

        .overlay {
            top: 35px;
        }
    }

    .v-dialog {
        .about-me {
            &__row {
                strong {
                    display: block;
                    margin-left: 5px;
                }

                span {
                    display: block;
                    margin-left: 5px;
                }
            }
        }

        .details-view {
            text-align: justify;
            p {
                word-wrap: break-word;
            }
        }
    }
    @media (max-width: 767px) {
        .about-me {
            .my-family {
                &__row {
                    padding-left: 70px;
                    margin-bottom: 0;
                }
            }
        }
    }
</style>
<style lang="scss">
    @import "../../common/styles/_colors.scss";

    .custom-expansion-panel {
            border-bottom: 2px solid black;
            box-shadow: 0px 2px 1px -1px rgba(0,0,0,0), 0px 1px 1px 0px rgba(0,0,0,0), 0px 1px 3px 0px rgba(0,0,0,0);
            margin-bottom: 10px;
    }
    
    .my-biography {
        .details-view {
            margin-bottom: 0px !important;
        }

        textarea {
            font-size: 14px;
            height: 267px;
            resize: none;
        }

        .v-messages {
            display: none;
        }

        .v-counter {
            margin-left: 0;
        }

        .v-text-field {
            padding-top: 0px;
        }
    }

    .familyInterests {
        &__list {
            display: block;
        }

        .v-label {
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block !important;
            width: 100%;
            overflow: hidden;
            font-weight: 400 !important;
            font-size: 14px !important;
        }

        .v-input__control {
            display: block;
            overflow: hidden;
        }

        .v-input--selection-controls__input+.v-label {
            color: $black !important;
        }
    }
</style>
